<template>
  <div class="top-box">
    <div class="top-left scroll-bar-better">
      <div>
        <span class="classification-title">分类</span>
      </div>
      <div class="classification-box">
        <div
          v-for="(item, index) in classList"
          :key="index"
          class="classification-wrap"
        >
          <div class="title" @click="handleIsLogin('parts-list', item)">
            <img
              style="width: 18px; height: 18px"
              v-bind:src="item.Code | icon"
            />
            <span class="title-name">{{ item.Name }}</span>
          </div>
          <div class="content">
            <span
              class="pointer"
              @click="handleIsLogin('parts-list', subItem)"
              v-for="(subItem, subIndex) in item.list"
              :key="subIndex"
              >{{ !subIndex ? "" : " / " }}{{ subItem.Name }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="top-right">
      <div class="type-box">
        <span
          @click="handleChangeTab(`${item.val}`)"
          class="type-item"
          :class="{ activeColor: item.val == tabType }"
          v-for="(item, index) in navList1"
          :key="index"
          >{{ item.navName }}</span
        >
      </div>
      <div class="swiper-login-box">
        <el-carousel indicator-position="none">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <div class="swiper-box">
              <el-image
                style="width: 100%; height: 100%"
                :src="item.Url"
                fit="cover"
              ></el-image>
            </div>
          </el-carousel-item>
        </el-carousel>

        <div class="login-register-box">
          <div class="avatar-wrap" v-if="info.HeadPic" @click="hadelGomine()">
            <el-avatar :size="120" :src="info.HeadPic"></el-avatar>
          </div>
          <div class="avatar-wrap" v-else @click="hadelGomine()">
            <el-avatar
              :size="120"
              :src="require('@/assets/tourist/avatar.png')"
            ></el-avatar>
          </div>
          <template v-if="!name">
            <div class="name-wrap">
              <div>Hi~欢迎来到配琪商城</div>
            </div>
            <div class="button-wrap">
              <el-button @click="handleLogin" class="login-button" round
                >登录</el-button
              >
              <router-link to="/register">
                <el-button class="register-button" round>注册</el-button>
              </router-link>
            </div>
          </template>
          <div style="margin-top: 10px" v-else>
            <div class="logined-Hi">Hi</div>
            <div class="logined-name" v-if="name != '暂未填写用户名'">
              {{ name }}
            </div>
          </div>

          <div class="order-wrap">
            <div @click="hadelGoOrder('DFK')" style="cursor: pointer">
              <div v-if="!qtyLoading && isshowNum == false" class="order-num">
                {{ qtyObj.DFK }}
              </div>

              <div v-if="isshowNum" class="order-num">0</div>
              <div
                v-if="qtyLoading && isshowNum == false"
                class="qty-loading-box"
                v-loading="qtyLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
              ></div>

              <div class="order-type">待付款</div>
            </div>
            <div @click="hadelGoOrder('DFH')" style="cursor: pointer">
              <div v-if="!qtyLoading && isshowNum == false" class="order-num">
                {{ qtyObj.DFH }}
              </div>
              <div v-if="isshowNum" class="order-num">0</div>
              <div
                v-if="qtyLoading && isshowNum == false"
                class="qty-loading-box"
                v-loading="qtyLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
              ></div>
              <div class="order-type">待发货</div>
            </div>
            <div @click="hadelGoOrder('YFH')" style="cursor: pointer">
              <div v-if="!qtyLoading && isshowNum == false" class="order-num">
                {{ qtyObj.YFH }}
              </div>
              <div v-if="isshowNum" class="order-num">0</div>
              <div
                v-if="qtyLoading && isshowNum == false"
                class="qty-loading-box"
                v-loading="qtyLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
              ></div>
              <div class="order-type">已发货</div>
            </div>
          </div>
          <template v-if="token">
            <div
              v-if="orderLoading"
              style="
                height: 58px;
                font-size: 30px;
                border-radius: 5px;
                overflow: hidden;
              "
              v-loading="orderLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
            ></div>

            <el-carousel
              v-else
              style="margin-top: 20px; border-radius: 5px"
              height="58px"
              direction="vertical"
              indicator-position="none"
              trigger="click"
              :class="orderList.length == 0 ? 'isDisplayNone' : ''"
            >
              <el-carousel-item v-for="(item, index) in orderList" :key="index">
                <router-link :to="`/mine/ordeDetail?id=${item.ID}`">
                  <div class="xiadan">
                    <div style="font-size: 0">
                      <el-image
                        style="width: 58px; height: 58px"
                        :src="item.Pic"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="desc-wrap">
                      <div class="status">{{ item.StatusName }}</div>
                      <div class="name">{{ item.Name }}</div>
                    </div>
                  </div>
                </router-link>
              </el-carousel-item>
            </el-carousel>
            <div
              class="replace"
              v-if="orderList.length == 0 && orderLoading == false"
            >
              <img src="@/assets/tourist/none.svg" alt="" />
              <div class="text">暂无订单</div>
              <!-- <el-empty description="描述文字"></el-empty> -->
            </div>
          </template>

          <div class="other-wrap">
            <div class="other-box pointer" @click="handleIsLogin('/cart')">
              <img
                class="icon"
                style="height: 20px; width: 20px"
                src="@/assets/dash_common/cart.png"
              />
              <span class="icon-text">购物车</span>
            </div>
            <!-- <div class="other-box pointer" @click="handleIsLogin">
							<img class="icon" src="@/assets/dash_common/favourite.png" />
							<span class="icon-text">宝贝收藏</span>
						</div> -->
            <div
              class="other-box pointer"
              @click="handleIsLogin('/mine/ordeRlist')"
            >
              <img class="icon" src="@/assets/dash_common/order.png" />
              <span class="icon-text">我的订单</span>
            </div>
            <!-- <div class="other-box pointer" @click="handleIsLogin">
							<img class="icon" src="@/assets/dash_common/history.png" />
							<span class="icon-text">我的足迹</span>
						</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState,mapGetters } from "vuex";
import {
  VehicleStructure,
  TopBanner,
  OrderQty,
  TopOrder,
} from "@/api/merchant/dashboard";
import { TopActiveBanner } from "@/api/activity.js";
// import { VehicleStructure,TopBanner,GetOrderList } from "@/api/merchant/dashboard";
export default {
  props: {
    tabType: String,
    listActivity: Array,
  },
  data() {
    return {
      navList: [
        { navName: "首页", val: "shouye", navIcon: "icon" },
        { navName: "活动专区", val: "activity", navIcon: "icon" },
        { navName: "配件商城", val: "shop", navIcon: "icon" },
        { navName: "精品车源", val: "source", navIcon: "icon" },
        { navName: "竞价中心", val: "auction", navIcon: "icon" },
      ],
      navList1: [],
      tabIndex: 0,

      classList: [],
      bannerList: [],
      qtyObj: {},
      qtyLoading: true,
      orderList: [],
      orderLoading: true,
      isshowNum: false, //是否展示发货数量
    };
  },
  computed: {
    ...mapState({
      // name: (state) => state.user.name
      info: (state) =>
        state.user.info && JSON.stringify(state.user.info) != "{}"
          ? JSON.parse(state.user.info)
          : {},
      name: (state) => (state.user.name != "" ? state.user.name : ""),
    }),
    ...mapGetters(["token"])
  },
  mounted() {
    // console.log(this.listActivity)
    // if (this.listActivity[1].Name == "") {
    // 	this.navList.splice(
    // 		this.navList.findIndex((item) => item.navName == "活动专区"),
    // 		1
    // 	)
    // }
    // console.log(this.navList)
  },
  watch: {
    listActivity: {
      handler(e) {
        console.log(e);
        if (e[1].Name == "") {
          this.navList.splice(
            this.navList.findIndex((item) => item.navName == "活动专区"),
            1
          );
          this.navList1 = this.navList;
          console.log("ssssssssssss", this.navList);
        } else if (e[1].Name != "") {
          this.navList1 = this.navList;
          console.log(this.navList1)
        }
        // if (e[1].Name == "") {
        // 	console.log(e[1], 899999999)
        // 	this.navList.splice(
        // 		this.navList.findIndex((item) => item.navName == "活动专区"),
        // 		1
        // 	)
        // 	return (this.navList1 = this.navList)
        // } else {
        // 	this.navList1 = this.navList
        // }
      },
      deep: true,
      // immediate: true
    },
    $route(to, form) {
      console.log(to);
    },
  },
  created() {
    // TopActiveBanner().then((res) => {
    // 	console.log(res)
    // 	// if (res[2].Name) {
    // 	// 	let obj = {navName: res[2].Name, val: "activity", navIcon: "icon"}
    // 	// 	this.navList.push(obj)
    // 	// }
    // })
    VehicleStructure().then((res) => {
      this.classList = res;
    });
    TopBanner().then((res) => {
      this.bannerList = res;
    });
    // console.log(this.$store.getters.token)
    if (this.$store.getters.token) {
      OrderQty().then((res) => {
        this.qtyObj = res.reduce((prev, item) => {
          prev[item.OrderType] = item.Qty;

          return prev;
        }, {});
        this.isshowNum = false;
        this.qtyLoading = false;
      });
    } else {
      this.isshowNum = true;
    }

    if (this.token) {
      TopOrder().then((res) => {
        this.orderList = res;
        console.log(res.length);
        this.orderLoading = false;
      });
    }

    // GetOrderList().then(res=>{
    // 	debugger
    // })
  },
  filters: {
    icon: function (value) {
      if (!value) return "";
      switch (value) {
        case "001": //车身部分
          return require("@/assets/tourist/cs.png");
        case "002": //电器照明系统
          return require("@/assets/tourist/zm.png");
        case "003": //发动机与变速器
          return require("@/assets/tourist/fdj.png");
        case "004": //底盘部分
          return require("@/assets/tourist/dp.png");
      }
    },
  },
  methods: {
    hadelGoOrder(e) {
      this.$router.push({
        path: "/mine/ordeRlist",
        query: {
          StatusCode: e,
        },
      });
    },
    hadelGomine() {
      this.$router.push("/mine");
    },
    handleLogin() {
      this.$emit("login", true);
    },
    handleIsLogin(path, cur) {
      if (!this.token) {
        this.handleLogin();
        // return true;
      } else {
        if (path.match(/^parts-list$/)) {
          this.$router.push({ name: "parts-list", params: { structure: cur } });
          return;
        }
        this.$router.push(path);
      }
    },
    handleChangeTab(e) {
      if (!this.token) {
        this.handleLogin();
        return true;
      }
      if (e == "shop" || e == "source" || e == "auction") {
        switch (e) {
          case "shop":
            this.$router.push("/parts-list");
            break;
          case "source":
            this.$router.push("/options");
            break;
          default:
            this.$router.push("/badding?type=partComponent");
        }
        return false;
      } else {
        this.$emit("scroll", e);
      }

      //  this.$emit("update:tab-type",e)
    },
  },
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
// .xiadan {
//   margin-top: 20px;
//   height: 58px;
//   border-radius: 5px;
//   background: rgba(232, 232, 232, 1);
// }
.isDisplayNone {
  display: none;
}
.replace {
  margin-top: 20px;
  height: 58px;
  // background: pink;
  img {
    height: 38px;
    width: auto;
  }
  .text {
    margin-top: 2px;
  }
}
.top-box {
  display: grid;
  grid-template-columns: 225px 1fr;
  // height: 496px;
  .top-left {
    background-color: #1d2089;
    border-radius: 10px;
    color: rgba(255, 255, 255, 1);
    padding: 10px 15px;
    overflow: auto;
    .classification-title {
      font-size: 20px;
      font-weight: 700;
    }
    .classification-box {
      .classification-wrap {
        margin-top: 18px;
        .title {
          display: flex;
          align-items: center;
          font-size: 16px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
          .title-name {
            margin-left: 8px;
          }
        }
        .content {
          margin-top: 8px;
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
  .top-right {
    display: grid;
    grid-template-rows: 50px 1fr;
    margin-left: 5px;
    .type-box {
      opacity: 1;
      border-radius: 10px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      .type-item {
        cursor: pointer;
        margin: 9px 10px;
        padding: 0 48px 0 28px;
        // line-height: 10px;
        border-right: 2px solid rgba(204, 204, 204, 1);
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        // color: rgba(29, 32, 137, 1);
        color: rgba(56, 56, 56, 1);
        // &::after {
        //   display: block;
        //   content: "";
        //   width: 2px;
        //   height: 30px;
        //   background: rgba(204, 204, 204, 1);
        // }
      }
      .activeColor {
        color: rgba(29, 32, 137, 1);
      }
    }
    .swiper-login-box {
      // display: flex;
      // align-items: center;
      display: grid;
      grid-template-columns: 1fr 225px;
      margin-top: 5px;
      .swiper-box {
        // flex: 1;
        height: 100%;
        // border-radius: 10px;
        // overflow: hidden;
      }
      .login-register-box {
        // width: 225px;

        margin-left: 5px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 1);
        padding: 23px 14px;
        text-align: center;
        .avatar-wrap {
          cursor: pointer;
          display: flex;
          justify-content: center;
        }
        .name-wrap {
          margin: 15px 0;
          text-align: center;
          font-size: 16px;
          font-weight: 400;
          color: rgba(56, 56, 56, 1);
        }
        .button-wrap {
          display: flex;
          justify-content: space-around;
        }
        .logined-Hi {
          font-size: 16px;
          font-weight: 400;
          color: rgba(56, 56, 56, 1);
        }
        .logined-name {
          font-size: 18px;
          font-weight: 700;
          color: rgba(56, 56, 56, 1);
        }
        .order-wrap {
          display: flex;
          justify-content: space-around;
          margin-top: 35px;
          .order-num {
            font-size: 22px;
            font-weight: 500;
            color: rgba(254, 118, 72, 1);
          }
          .order-type {
            font-size: 14px;
            font-weight: 400;
            color: rgba(56, 56, 56, 1);
          }
        }
        .other-wrap {
          margin-top: 22px;
          display: grid;
          grid-template-columns: repeat(2, auto);
          grid-template-rows: repeat(2, auto);
          grid-row-gap: 18px;
          justify-content: space-around;
          // text-align: left;
          .other-box {
            display: flex;

            // margin: auto 0;
            // vertical-align: middle;
            // flex-direction: column;
            // justify-content: center;
          }
          .icon {
            vertical-align: middle;
            width: 18px;
            height: 18px;
          }
          .icon-text {
            margin-left: 7px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
            // flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: left;
          }
        }
        .xiadan {
          display: grid;
          grid-template-columns: auto 1fr;
          overflow: hidden;
          align-items: center;
          height: 58px;
          // border-radius: 5px;
          background: rgba(232, 232, 232, 1);
          .desc-wrap {
            text-align: left;
            padding: 8px;
            .status {
              font-size: 14px;
              font-weight: 400;
              color: rgba(56, 56, 56, 1);
            }
            .name {
              font-size: 10px;
              font-weight: 400;
              color: rgba(92, 92, 92, 1);
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.qty-loading-box {
  margin-bottom: 5px;
  .el-icon-loading {
    font-size: 22px;
  }
}
.swiper-login-box {
  .el-carousel__container {
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
  }
}
.login-register-box {
  .button-wrap {
    .el-button {
      padding-right: 25px;
      padding-left: 25px;
      border-radius: 50px;
      font-size: 17px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      &:nth-of-type(1) {
        background: rgba(254, 118, 72, 1) !important;
      }

      &.register-button {
        background: rgba(29, 32, 137, 1) !important;
      }
    }
  }
}
</style>
